//const beserver = "http://localhost:4000"
//const beserver = "https://be.pslnol.xyz:4000"
const beserver = "https://be.pslnol.xyz:443"
export const dasLoginUrl = beserver + '/api/auth/signin';
export const dasSignupUrl = beserver + '/api/auth/signup';
export const dasVerifyEmailUrl = beserver + '/api/auth/verify';
export const dasRefreshTokenUrl = beserver + '/api/auth/refreshtoken';
export const dasGraphQLUrl = beserver + "/api/graphql";
